module.exports = __webpack_public_path__ + "img/silver_50x50.652fd65a.png";